module.exports = __webpack_public_path__ + "img/green_020.4c973b95.png";